import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import { formatNumber } from '../../Utils/Money';

const printRecipt = async (dataFee, clinicData) => {

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    //Tabla de Contenido

    let itemBody = [
        [
            {
                text: "Paciente",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "F. Admision",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Servicio",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Entidad",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Valor",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Pactado",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Total",
                style: "tableHeader",
                alignment: "center",
            }
        ],
    ];
    let itemArr = ["", "", "", "", "", "", ""];
    if (dataFee.honorarios_profesional.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < dataFee.honorarios_profesional.length; index++) {
        const element = dataFee.honorarios_profesional[index];
        itemBody.push([
            { text: element.nombre_paciente, alignment: "center" },
            { text: moment(element.fecha_admision).format("DD-MM-YYYY hh:mm"), alignment: "center" },
            { text: element.nombre_servicio, alignment: "center" },
            { text: element.nombre_tercero, alignment: "center" },
            { text: '$' + formatNumber(element.costo_servicio), alignment: "center" },
            { text: element.pactado, alignment: "center" },
            { text: '$' + formatNumber(element.liquidacion), alignment: "center" },
        ]);
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        info: {
            author: "MFV HEALTH",
        },
        content: [
            {
                margin: [0, 0, -20, 0],
                layout: 'noBorders',
                table: {
                    widths: ['*', 'auto', '*'],
                    body: [
                        [{
                            image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + clinicData.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                            fit: [180, 90],
                            alignment: 'center'
                        },
                        {
                            layout: 'noBorders',
                            table: {
                                body: [
                                    [{ text: clinicData.nombre, style: 'texthead', alignment: 'center' }],
                                    [{ text: 'NIT: : ' + clinicData.nit, style: 'texthead', alignment: 'center' }],
                                    /* [{ text: clinicData.direccion.direccion, style: 'texthead', alignment: 'center' }],
                                    [{ text: clinicData.telefono1, style: 'texthead', alignment: 'center' }],
                                    [{ text: clinicData.email  , style: 'texthead', alignment: 'center' }],
                                    [{ text: clinicData.nombre_ciudad + "-" + clinicData.nombre_departamento, style: 'texthead', alignment: 'center' }], */
                                ],
                                alignment: 'center',
                            },
                        },
                        {
                            layout: 'noBorders',
                            table: {
                                body: [
                                    [{ text: "", style: 'head', alignment: 'center' }]
                                ],
                                alignment: 'center',
                            },
                        }],
                    ],
                },
            },
            {
                width: "auto",
                fontSize: 10,
                text: [
                    {
                        text: "\n\n"
                    },
                ],
                alignment: "center"
            },
            {
                margin: [0, -5],
                layout: 'exampleLayout',
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', '*'],
                    body: [
                        [
                            { text: 'Fecha Inicial:', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: moment(dataFee.fecha_inicial).format("DD/MM/YYYY"), style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: 'Fecha Final:', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: moment(dataFee.fecha_final).format("DD/MM/YYYY"), style: 'textStyle', /*border: [false, false, false, false]*/ }
                        ]
                    ],

                },
            },
            {
                margin: [0, 5],
                layout: 'exampleLayout',
                table: {
                    headerRows: 1,
                    widths: ['auto', '*'],
                    body: [
                        [
                            { text: 'Profesional en Salud:', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: dataFee.nombre_profesional.toUpperCase(), style: 'textStyle', /*border: [false, false, false, false]*/ }
                        ]
                    ],

                },
            },
            {
                margin: [0, 10, 0, 0],
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                margin: [0, 10, 0, 0],
                layout: 'exampleLayout',
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', '*'],
                    body: [
                        [
                            { text: '', bold: true, style: 'textStyle', border: [false, false, false, false] },
                            { text: '', style: 'textStyle', border: [false, false, false, false] },
                            { text: 'Subtotal', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: '$' + formatNumber(dataFee.subtotal.toFixed()), style: 'textStyle', /*border: [false, false, false, false]*/ }
                        ],
                        [
                            { text: '', bold: true, style: 'textStyle', border: [false, false, false, false] },
                            { text: '', style: 'textStyle', border: [false, false, false, false] },
                            { text: 'Retención (10%)', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: '$' + formatNumber(dataFee.retencion.toFixed()), style: 'textStyle', /*border: [false, false, false, false]*/ }
                        ],
                        [
                            { text: '', bold: true, style: 'textStyle', border: [false, false, false, false] },
                            { text: '', style: 'textStyle', border: [false, false, false, false] },
                            { text: 'Total', bold: true, style: 'textStyle', /*border: [false, false, false, false]*/ },
                            { text: '$' + formatNumber(dataFee.total.toFixed()), style: 'textStyle', /*border: [false, false, false, false]*/ }
                        ]
                    ],
                },
            },
            {
                // auto-sized columns have their widths based on their content                                       
                margin: [40, 60, 25, 0],
                layout: 'headerLineOnly',
                table: {
                    widths: [110],
                    headerRows: 1,
                    body: [
                        [{ text: '' }],
                        [{ text: 'Profesional en Salud', style: 'foot', }],
                        [{ text: dataFee.nombre_profesional.toUpperCase(), style: 'foot', }],
                    ]
                },
            },
        ],
        styles: {
            head: {
                fontSize: 8,
                alignment: 'center'
            },
            textStyle: {
                fontSize: 10,
            },
            tableExample: {
                fontSize: 7,
            },
            foot: {
                fontSize: 7
            },
            texthead: {
                alignment: 'center',
                fontSize: 12,
            }
        }
    }

    pdfMake.createPdf(documentDefinition).open();
}

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default printRecipt;